import React from 'react';
import {Stack, SxProps, Typography} from '@mui/material';
import TableFilterArrow from '../../../_commons/components/Table/TableFilterArrow';
import {Theme} from '@mui/material/styles';
import {AllSystemCSSProperties, ResponsiveStyleValue} from '@mui/system';

export type SortOrder = 'asc' | 'desc' | null | undefined;

const headerTitleSxProps: SxProps<Theme> = {
  textTransform: 'uppercase',
  color: '#2BAC6B',
  fontFamily: 'BNPPSansCondensed',
  fontSize: '1.1rem',
  fontWeight: '500',
  letterSpacing: '0.12rem'
};

const SortableHeader = ({children, sort, setSorting, field, justifyContent}: React.PropsWithChildren<{
  sort: SortOrder,
  setSorting?: Function,
  field: string,
  justifyContent: ResponsiveStyleValue<AllSystemCSSProperties['justifyContent']>
}>) => {
  return (
    <Stack display={'flex'} justifyContent={justifyContent} direction={'row'} onClick={() => sort !== undefined && setSorting && setSorting((prevState: any) => ({
      ...prevState,
      order: sort === 'desc' ? 'asc' : 'desc',
      field: field
    }))}>
      <Typography variant={'h4'} textTransform={'uppercase'} sx={headerTitleSxProps}>{children}</Typography>
      {sort !== undefined && <TableFilterArrow sort={sort}/>}
    </Stack>
  );
};

export default SortableHeader;
